import {isImage} from '../utils/observeResources.js';
import collectResources from '../utils/collectResources.js';

export default function images(window, performance, PerformanceObserver) {
    return collectResources(window, performance, PerformanceObserver, 'images', isImage);
}
